package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.logic.NavigatorBagPage
import com.example.mystybag.appCore.model.pages.CategoryBagsListUIState
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel

class CategoryBagsListViewModel(
    context: AppContext,
    businessCategoryId: Long?,
    categoryTitle: String,
    bags: List<HomeTopPickUiModel>
) : ChildViewModel<CategoryBagsListUIState>(
    context,
    CategoryBagsListUIState(
        businessCategoryId = businessCategoryId,
        categoryTitle = categoryTitle,
        bags = bags
    )
) {
    override fun onCreate() {
        navControls.title = uiState.value.categoryTitle
        navControls.backButtonVisible = true
    }
    
    fun onBagClick(bagItem: HomeTopPickUiModel) {
        navigate(NavigatorBagPage(bagItem = bagItem))
    }
    
    fun onBackClick() {
        goBack()
    }
}
